// Merkan · Schreibschutz für "Ansicht als" (BR-06)
// Solange die Geschäftsführung die App mit den Rechten einer anderen Rolle ansieht, lässt der Supabase-Client
// nur lesende Anfragen durch: GET und HEAD an die Datenbank, lesende RPCs, signierte Links für Dateien.
// Schreibende Anfragen, Edge Functions und Uploads werden mit einer Klartextmeldung abgewiesen.
import { t } from './sprache';

let aktiv = false;

export function schreibschutzSetzen(an: boolean) {
  aktiv = an;
}

export function schreibschutzAktiv(): boolean {
  return aktiv;
}

/** RPCs, die nur lesen und darum auch in der Ansicht als erlaubt sind */
const LESEN = new Set([
  'meine_rechte', 'mein_zugang', 'meine_mandanten', 'mandant_nach_subdomain', 'meine_ip', 'ich_bin_plattform_admin',
  'dashboard', 'suche', 'suche_art', 'suche_direkt', 'ki_stand', 'vorschlag_aus_entscheidungen', 'protokoll_sicherheit',
  'portal_meine_zugaenge', 'meine_passkeys', 'ki_unterhaltungen_suchen', 'bank_zu_iban', 'bank_zu_blz', 'anleitungen_fuer',
  'ansicht_rollen', 'ansicht_als_protokollieren', 'meine_vertretungen', 'zahlung_zuordnung_vorschlagen',
]);

function gesperrt(): Response {
  const text = t('Ansicht als: nur Anzeige. Änderungen sind in dieser Ansicht gesperrt.');
  return new Response(JSON.stringify({ code: 'ansicht_als', message: text, details: null, hint: null, ok: false, hinweis: text }), {
    status: 403,
    headers: { 'Content-Type': 'application/json' },
  });
}

/** Prüft eine Anfrage; true = durchlassen */
export function anfrageErlaubt(url: string, methode: string): boolean {
  if (!aktiv) return true;
  const m = methode.toUpperCase();
  let pfad = url;
  try { pfad = new URL(url).pathname; } catch { /* relative Adresse */ }
  if (pfad.includes('/auth/v1/')) return true;
  if (pfad.includes('/functions/v1/')) return false;
  if (m === 'GET' || m === 'HEAD') return true;
  if (pfad.includes('/rest/v1/rpc/')) {
    const name = pfad.split('/rest/v1/rpc/')[1]?.split(/[/?]/)[0] ?? '';
    return LESEN.has(name);
  }
  if (pfad.includes('/storage/v1/object/sign/') || pfad.includes('/storage/v1/object/list/')) return true;
  return false;
}

/** fetch für den Supabase-Client */
export const geschuetztesFetch: typeof fetch = (eingabe, init) => {
  const url = typeof eingabe === 'string' ? eingabe : eingabe instanceof URL ? eingabe.href : eingabe.url;
  const methode = init?.method ?? (typeof eingabe === 'object' && 'method' in eingabe ? eingabe.method : 'GET');
  if (!anfrageErlaubt(url, methode)) return Promise.resolve(gesperrt());
  return fetch(eingabe, init);
};
